import { useFormikContext } from 'formik'

import { Associations } from 'src/components/associations'
import { HelperWrapper } from 'src/components'
import { AssociationsType, IProductForm } from 'src/types'
import { useJourneysSelection } from 'src/hooks'

interface IProps {
  isDisabled?: boolean
}

const JourneyAssociationInput = ({ isDisabled }: IProps) => {
  const { values, setFieldValue } = useFormikContext<IProductForm>()
  const selectedJourneys = values.selectedJourney ? [values.selectedJourney] : []
  const { selectedJourneyIcons } = useJourneysSelection(selectedJourneys)

  const setSelectedJourneys = (ids: string[]) => {
    setFieldValue('selectedJourney', ids[0])
  }

  const handleJourneySelect = (id: string) => {
    setFieldValue('selectedJourney', values.selectedJourney === id ? null : id)
  }

  return (
    <Associations
      disabled={isDisabled}
      setSelectedItems={setSelectedJourneys}
      type={AssociationsType.JOURNEYS}
      description={
        <HelperWrapper
          t="journeys-association-title"
          isColorInherited
          size={11}
          verticalPosition={15}
        />
      }
      selectedItems={selectedJourneys}
      handleSelectItem={handleJourneySelect}
      selectedIcons={selectedJourneyIcons}
      isRound
      hideCount
    />
  )
}

export { JourneyAssociationInput }
